// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tiqbdbpoufpujbeuhxjq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRpcWJkYnBvdWZwdWpiZXVoeGpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM2NTI0MTUsImV4cCI6MjA1OTIyODQxNX0.nSnsDZ0QtN9j5V1B_XcBESQF54JuPxsBfn2x8aOSQG0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});